/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {createAutoCorrectedDatePipe} from 'text-mask-addons/dist/textMaskAddons';

export const DATE_FORMAT: string = 'YYYY-MM-DD';
export const DR_DATE_FORMAT: string = 'YYYYMMDD';

export const GP_DATE_FORMAT: Array<any> = [
  'DD.MM.YYYY',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
  'DD/MM/YYYY',
  'YYYY-MM-DD'
];

export enum DATE_FORMATS {
  FR = 'DD/MM/YYYY',
  US = 'YYYY-MM-DD',
  RU = 'YYYY-MM-DD',
  EG = 'YYYY-MM-DD',
  IT = 'DD.MM.YY',
  ES = 'DD-MM-YY',
  AU = 'YYYY-MM-DD',
  CN = 'YYYY-MM-DD',
  NL = 'YYYY-MM-DD',
  PT = 'YYYY-MM-DD',
  GB = 'DD/MM/YYYY',
  DE = 'YYYY-MM-DD',
}




export enum DISPLAY_TYPE {
  DECIMAL_ALL_DIGITS = 'DECIMAL_ALL_DIGITS',
  DECIMAL = 'DECIMAL',
  DECIMAL_1_DIGIT = 'DECIMAL_1_DIGIT',
  DECIMAL_2_DIGIT = 'DECIMAL_2_DIGIT',
  DECIMAL_3_DIGIT = 'DECIMAL_3_DIGIT',
  DECIMAL_4_DIGIT = 'DECIMAL_4_DIGIT',
  DECIMAL_5_DIGIT = 'DECIMAL_5_DIGIT',
  DECIMAL_6_DIGIT = 'DECIMAL_6_DIGIT',
  DECIMAL_7_DIGIT = 'DECIMAL_7_DIGIT',
  DECIMAL_8_DIGIT = 'DECIMAL_8_DIGIT',
  DECIMAL_9_DIGIT = 'DECIMAL_9_DIGIT',
  DECIMAL_10_DIGIT = 'DECIMAL_10_DIGIT',
  DECIMAL_UP_TO_4_DIGIT = 'DECIMAL_UP_TO_4_DIGIT',
  INTEGER = 'INTEGER',
  CURRENCY = 'CURRENCY',
  CURRENCY_1_DIGIT = 'CURRENCY_1_DIGIT',
  CURRENCY_2_DIGIT = 'CURRENCY_2_DIGIT',
  CURRENCY_3_DIGIT = 'CURRENCY_3_DIGIT',
  CURRENCY_4_DIGIT = 'CURRENCY_4_DIGIT',
  CURRENCY_5_DIGIT = 'CURRENCY_5_DIGIT',
  CURRENCY_6_DIGIT = 'CURRENCY_6_DIGIT',
  CURRENCY_7_DIGIT = 'CURRENCY_7_DIGIT',
  CURRENCY_8_DIGIT = 'CURRENCY_8_DIGIT',
  CURRENCY_9_DIGIT = 'CURRENCY_9_DIGIT',
  CURRENCY_10_DIGIT = 'CURRENCY_10_DIGIT',
  CURRENCY_UP_TO_4_DIGIT = 'CURRENCY_UP_TO_4_DIGIT',
  PERCENT = 'PERCENT',
  PERCENT_1_DIGIT = 'PERCENT_1_DIGIT',
  PERCENT_2_DIGIT = 'PERCENT_2_DIGIT',
  PERCENT_3_DIGIT = 'PERCENT_3_DIGIT',
  PERCENT_4_DIGIT = 'PERCENT_4_DIGIT',
  PERCENT_5_DIGIT = 'PERCENT_5_DIGIT',
  PERCENT_6_DIGIT = 'PERCENT_6_DIGIT',
  PERCENT_7_DIGIT = 'PERCENT_7_DIGIT',
  PERCENT_8_DIGIT = 'PERCENT_8_DIGIT',
  PERCENT_9_DIGIT = 'PERCENT_9_DIGIT',
  PERCENT_10_DIGIT = 'PERCENT_10_DIGIT',
  PERCENT_UP_TO_4_DIGIT = 'PERCENT_UP_TO_4_DIGIT',
  NA = 'NA'
}

export const NUMBER_FORMATS = {
  FR: {
    separator: ' ',
    decimal: ','
  },
  US: {
    separator: ',',
    decimal: '.'
  },
  RU: {
    separator: ',',
    decimal: '.'
  },
  EG: {
    separator: ',',
    decimal: '.'
  },
  IT: {
    separator: '.',
    decimal: ','
  },
  ES: {
    separator: '.',
    decimal: ','
  },
  AU: {
    separator: ',',
    decimal: '.'
  },
  CN: {
    separator: ' ',
    decimal: ','
  },
  NL: {
    separator: ',',
    decimal: '.'
  },
  PT: {
    separator: ',',
    decimal: '.'
  },
  GB: {
    separator: ',',
    decimal: '.'
  },
  DE: {
    separator: ' ',
    decimal: ','
  }
};

export const GP_SEARCH_COLOR_LEGAL_ORGANIZATIONS = '103,127,212';
export const GP_SELECTED_NODE = '51,75,161';
export const GP_SELECTED_NODE_ERROR = '191,0,49';
export const GP_TEXT_NODE = '135,11,88';

// Tree node colors – white background, soft-blue outline, black name + grey subtitles
export const GP_PRIMARY = '0,109,216';           // $primary #006dd8
export const GP_NODE_BG = '#ffffff';             // white node background
export const GP_NODE_BG_DISABLED = '#f4f5f6';    // light grey for disabled/backup nodes
export const GP_NODE_TEXT = '#ffffff';           // white text (backup overlay)
export const GP_NODE_BORDER = '#8fa0dd';         // soft-blue outline border
export const GP_NODE_BORDER_RGB = '143,160,221'; // soft-blue outline border as r,g,b (fallback for backend colors)
export const GP_NODE_BORDER_ERROR = '#ff979d';   // $red-brand-80 – soft red outline for vacant nodes
export const GP_NODE_NAME_TEXT = '#000000';      // bold black node name
export const GP_NODE_SUBTITLE_TEXT = '#565759';  // darker grey subtitles (between $slate-gray #737476 and $tuna-gray #323334)

// Avatar colors – kept in sync with the employee-list avatar ($avatar-* in sdwds/_variables.scss)
export const GP_AVATAR_INITIALS = '#005389';
export const GP_AVATAR_BORDER = '#0073b8';
export const GP_AVATAR_BG = '#edfbff';

// Accent avatar colors – used by the company (org) tree, matching the entity/top-card avatar ($accent / $accent-30)
export const GP_AVATAR_ACCENT_INITIALS = '#001c52';
export const GP_AVATAR_ACCENT_BORDER = '#001c52';
export const GP_AVATAR_ACCENT_BG = '#c7dff6';

export const DATE_MIN: string = '1970-01-01';
export const DATE_MAX: string = '3000-01-01';

// response status error codes
export enum ResponseStatusCodes {
  OK = 200,
  UploadedSuccesfully = 201,
  NoContent = 204,
  BadRequestCode = 400,
  UnauthorizedCode = 401,
  ForbiddenCode = 403,
  NotFoundCode = 404,
  ConflictCode = 409,
  UnprocessableEntityCode = 422,
  NetworkAuthenticationRequiredCode = 511,
  Timeout = 524
}

export const GP_TIMEZONE_LIST: Array<any> = [
  {name: 'Greenwich Mean Time', value: 'Etc/GMT0'},
  {name: '(GMT+1) European Central Time', value: 'Etc/GMT-1'},
  {name: '(GMT+2) Eastern European Time', value: 'Etc/GMT-2'},
  {name: '(GMT+3) Eastern African Time', value: 'Etc/GMT-3'},
  {name: '(GMT+4) Near East Time', value: 'Etc/GMT-4'},
  {name: '(GMT+5) Pakistan Lahore Time', value: 'Etc/GMT-5'},
  {name: '(GMT+6) Bangladesh Standard Time', value: 'Etc/GMT-6'},
  {name: '(GMT+7) Vietnam Standard Time', value: 'Etc/GMT-7'},
  {name: '(GMT+8) China Taiwan Time', value: 'Etc/GMT-8'},
  {name: '(GMT+9) Japan Standard Time', value: 'Etc/GMT-9'},
  {name: '(GMT+10) Australia Eastern Time', value: 'Etc/GMT-10'},
  {name: '(GMT+11) Solomon Standard Time', value: 'Etc/GMT-11'},
  {name: '(GMT+12) New Zealand Standard Time', value: 'Etc/GMT-12'},
  {name: '(GMT-11) Midway Islands Time', value: 'Etc/GMT+11'},
  {name: '(GMT-10) Hawaii Standard Time', value: 'Etc/GMT+10'},
  {name: '(GMT-9) Alaska Standard Time', value: 'Etc/GMT+9'},
  {name: '(GMT-8) Pacific Standard Time', value: 'Etc/GMT+8'},
  {name: '(GMT-7) Phoenix Standard Time', value: 'Etc/GMT+7'},
  {name: '(GMT-6) Central Standard Time', value: 'Etc/GMT+6'},
  {name: '(GMT-5) Eastern Standard Time', value: 'Etc/GMT+5'},
  {name: '(GMT-4) Puerto Rico and US Virgin Islands Time', value: 'Etc/GMT+4'},
  {name: '(GMT-3) Argentina Standard Time', value: 'Etc/GMT+3'},
  {name: '(GMT-1) Central African Time', value: 'Etc/GMT+1'}
];

export const NUMBER_FORMAT: any = {
  separator: ',',
  decimal: '.'
};

export const NUMBER_SEPARATOR_SYMBOLS: any = [',', '.', ' ', '\''];
export const NUMBER_DECIMAL_SYMBOLS: any = [',', '.'];

// config for CSV exports
export const CSV_ColumnDelimiter: string = ';';
export const CSV_LineDelimiter: string = '\n';

export const colorCodeRGBMask: RegExp = /(\d{1,3}),(\d{1,3}),(\d{1,3})/;

// masks for input fields
export const GP_DATE_MASK: any = {
  'DD.MM.YYYY': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('DD.MM.YYYY'.toLowerCase()),
    keepCharPositions: true
  },
  'MM-DD-YYYY': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('MM-DD-YYYY'.toLowerCase()),
    keepCharPositions: true
  },
  'DD-MM-YYYY': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('DD-MM-YYYY'.toLowerCase()),
    keepCharPositions: true
  },
  'DD/MM/YYYY': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('DD/MM/YYYY'.toLowerCase()),
    keepCharPositions: true
  },
  'YYYY-MM-DD': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('YYYY-MM-DD'.toLowerCase()),
    keepCharPositions: true
  }
};

export const GP_MONTH_MASK = {
  'MM.YYYY': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('MM.YYYY'.toLowerCase()),
    keepCharPositions: true
  },
  'MM-YYYY': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('MM-YYYY'.toLowerCase()),
    keepCharPositions: true
  },
  'MM/YYYY': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('MM/YYYY'.toLowerCase()),
    keepCharPositions: true
  },
  'YYYY-MM': {
    placeholderChar: ' ',
    guide: true,
    mask: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('YYYY-MM'.toLowerCase()),
    keepCharPositions: true
  }
};

export const getMonthFormat = (format: string) => {
  switch (format) {
    case 'YYYY-MM-DD':
      return 'YYYY-MM';
    case 'DD/MM/YYYY':
      return 'MM/YYYY';
    case 'DD-MM-YYYY':
    case 'MM-DD-YYYY':
      return 'MM-YYYY';
    case 'DD.MM.YYYY':
      return 'MM.YYYY';
  }
};

const IEResize = document.createEvent('UIEvents');
IEResize.initEvent('resize', true, false);
export const RESIZE_EVENT = (
  window.navigator.userAgent.indexOf('MSIE') !== -1
  || window.navigator.userAgent.indexOf('rv:') !== -1)
  ? IEResize
  : new Event('resize');

export const IS_IE: boolean = window.navigator.userAgent.indexOf('MSIE') !== -1
  || window.navigator.userAgent.indexOf('rv:') !== -1;

// api constants
export enum ObserveType {
  RESPONSE = 'response',
  BODY = 'body',
  EVENTS = 'events'
}

export enum ResponseType {
  TEXT = 'text',
  ARRAY_BUFFER = 'arraybuffer',
  BLOB = 'blob',
  JSON = 'json'
}

export const REQUEST_OPTIONS: any = {
  OBSERVE: {
    get RESPONSE() {
      return {requestOptions: {observe: ObserveType.RESPONSE}};
    },
    get BODY() {
      return {requestOptions: {observe: ObserveType.BODY}};
    },
    get EVENTS() {
      return {requestOptions: {observe: ObserveType.EVENTS}};
    }
  },
  RESPONSE_TYPE: {
    get TEXT() {
      return {requestOptions: {responseType: ResponseType.TEXT}};
    },
    get ARRAY_BUFFER() {
      return {requestOptions: {responseType: ResponseType.ARRAY_BUFFER}};
    },
    get BLOB() {
      return {requestOptions: {responseType: ResponseType.BLOB}};
    },
    get JSON() {
      return {requestOptions: {responseType: ResponseType.JSON}};
    }
  }
};

export const DEFAULT_PRIORITY = 0;

export const ATTRIBUTE_MVEL_ALIAS = 'mvel-alias';

export interface Operator {
  display: string;
  value: FilterOperator;
  description: string;
}

export enum FilterOperator {
  EQUALS = 'EQUALS',
  EQUALS_WITH_CHILDREN = 'EQUALS_WITH_CHILDREN',
  DIFFERENT = 'DIFFERENT',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  BETWEEN = 'BETWEEN',
  CONTAINS = 'CONTAINS',
  IN = 'IN'
}

export const COMMON_OPERATORS: Operator[] = [
  {
    value: FilterOperator.EQUALS,
    display: '=',
    description: 'COMMON.equal'
  },
  {
    value: FilterOperator.DIFFERENT,
    display: '≠',
    description: 'COMMON.different'
  }
];

export const NUMBER_OPERATORS: Operator[] = [
  {
    value: FilterOperator.GREATER_THAN,
    display: '>',
    description: 'COMMON.greater_than'
  },
  {
    value: FilterOperator.LESS_THAN,
    display: '<',
    description: 'COMMON.less_than'
  },
  {
    value: FilterOperator.GREATER_THAN_OR_EQUAL,
    display: '≥',
    description: 'COMMON.greater_than_or_equal'
  },
  {
    value: FilterOperator.LESS_THAN_OR_EQUAL,
    display: '≤',
    description: 'COMMON.less_than_or_equal'
  }
];

export const DATE_OPERATORS: Operator[] = [
  {
    value: FilterOperator.BETWEEN,
    display: '<..>',
    description: 'COMMON.between'
  }
];

export const LIST_OPERATORS: Operator[] = [
  {
    value: FilterOperator.IN,
    display: 'in',
    description: 'COMMON.in'
  }
];

export const TREE_OPERATORS: Operator[] = [
  {
    value: FilterOperator.EQUALS_WITH_CHILDREN,
    display: '=⋱',
    description: 'COMMON.equal_with_children'
  }
];

export const LABEL_OPERATORS: Operator[] = [
  {
    value: FilterOperator.CONTAINS,
    display: '⊏⊐',
    description: 'COMMON.contains'
  }
];

export const ALL_OPERATORS: Operator[] = [
  ...COMMON_OPERATORS,
  ...NUMBER_OPERATORS,
  ...DATE_OPERATORS,
  ...LIST_OPERATORS,
  ...TREE_OPERATORS,
  ...LABEL_OPERATORS
];

export const ACCRUAL_STATUS_PREPARE_ESTIMATION = 'PREPARE_ESTIMATION';
export const ACCRUAL_STATUS_ESTIMATING: string = 'ESTIMATING';
export const ACCRUAL_STATUS_OUT_OF_RANGE: string = 'OUT_OF_RANGE';
export const ACCRUAL_STATUS_ESTIMATED: string = 'ESTIMATED';
export const ACCRUAL_STATUS_CONFIG_NOT_FOUND: string = 'CONFIG_NOT_FOUND';
export const ACCRUAL_STATUS_CONFIG_NOT_USABLE: string = 'CONFIG_NOT_USABLE';

export enum ProfileMode {
  CLASSIC = 'CLASSIC',
  ESS = 'ESS',
  MSS = 'MSS'
}
